import type * as React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { COLORS } from "components/v3/Theme/colors";
import Translate from "translate/Translate";
import GLButton from "components/v3/sharedComponents/GLButton";
import ModalWrapper from "components/v2/sharedComponents/Modals/ModalComponents/ModalWrapper";

type GettingStartedSurveyExitConfirmationModalProps = {
  descriptionText?: string;
  isOpen?: boolean;
  onCloseModal?: () => void;
};

const GettingStartedSurveyExitConfirmationModal: React.FC<GettingStartedSurveyExitConfirmationModalProps> = ({
  descriptionText = "Your answers will not be saved and suggested DNA screenings will not be available. You will be taken back to your dashboard. You can start the health questionnaire again at any point.",
  isOpen = false,
  onCloseModal
}) => {
  return (
    <ModalWrapper
      closeButton={true}
      closeOnBackdropClick={true}
      isOpen={isOpen}
      onClose={onCloseModal}
      modalContainerSx={{
        flexBasis: {
          xs: "90% !important"
        },
        maxHeight: "85vh",
        maxWidth: {
          xs: "95%",
          lg: "805px !important"
        },
        overflow: "auto",
        padding: {
          xs: "32px 16px 24px 16px !important",
          lg: "64px 32px 32px 32px !important"
        },
        margin: "auto",
        outline: 0
      }}
      sx={{
        "& .MuiModal-backdrop": {
          backgroundColor: `${COLORS.PRIMARY_DARKER}80`
        },
        outline: 0
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: 4,
          textAlign: "center"
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxWidth: {
              md: "75%"
            }
          }}
        >
          <Typography
            sx={{ typography: { xs: "body_strong", lg: "body_strong_lg" } }}
          >
            <Translate
              text={"You are exiting the health questionaire. Are you sure?"}
            />
          </Typography>
          <Typography sx={{ typography: { xs: "body_xs", xsm: "body" } }}>
            <Translate text={descriptionText} />
          </Typography>
        </Box>
        <Link
          to="/"
          name="Dashboard"
          style={{
            textDecoration: "none"
          }}
        >
          <GLButton buttonType="primary">
            <Typography variant="body_strong_white">
              <Translate text={"Skip for now"} />
            </Typography>
          </GLButton>
        </Link>
        <Box
          component="button"
          onClick={() => {
            onCloseModal();
          }}
          sx={{
            background: "transparent",
            border: "none",
            cursor: "pointer"
          }}
        >
          <Typography variant="body_strong_dark_gray">
            <Translate text="Continue" />
          </Typography>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default GettingStartedSurveyExitConfirmationModal;
